import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const LogoutOthersModal = ({ show, onConfirm, onCancel }) => {
  
  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title>Device Logout Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>This is to confirm that no other device is logged on.</p>
       
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default LogoutOthersModal;